// Five-product display protection, independent of video loading and theme role.
// Does not alter forms, cart events, variant selection or sticky trigger state.
const supportedProducts = new Set(['9725081649458','10238452302130','10238451876146','10238448107826','9734762496306']);
const purchaseInfo = document.querySelector('[data-takoo-five-product]');
if (supportedProducts.has(purchaseInfo?.dataset.takooFiveProduct)) {
  const html = document.documentElement;
  html.classList.add('takoo-five-clearance');
  let shift = 0;
  let queued = false;
  const observed = new WeakSet();
  const observer = new MutationObserver(schedule);
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(sync);
  }
  function sync() {
    queued = false;
    const root = document.querySelector('shopify-chat')?.shadowRoot;
    const runtime = root?.querySelector('shopify-agent-runtime');
    for (const scope of [root, runtime?.shadowRoot]) {
      if (scope && !observed.has(scope)) {
        observed.add(scope);
        observer.observe(scope, {childList:true, subtree:true, attributes:true, attributeFilter:['open','aria-expanded']});
      }
    }
    const launcher = root?.querySelector('[part="activator"]') || runtime?.shadowRoot?.querySelector('[part="activator"]');
    const open = Boolean(runtime?.hasAttribute('open') || launcher?.getAttribute('aria-expanded') === 'true');
    html.classList.toggle('takoo-five-chat-open', open);
    if (!launcher) return;
    const a = launcher.getBoundingClientRect();
    const baseBottom = a.bottom - shift;
    let bottom = baseBottom;
    if (!open) {
      const bar = document.querySelector('.sticky-add-to-cart__bar');
      const controls = [...document.querySelectorAll('main .buy-buttons-block button[type="submit"], main .buy-buttons-block shopify-accelerated-checkout')];
      // Protect the entire visible exit transition, not just data-stuck=true.
      if (bar) controls.push(bar);
      for (const el of controls) {
        const r = el.getBoundingClientRect();
        const style = getComputedStyle(el);
        if (r.height && r.width && r.bottom > 0 && r.top < innerHeight &&
            style.visibility !== 'hidden' && style.display !== 'none' &&
            a.left < r.right && a.right > r.left && bottom > r.top - 12 && bottom - a.height < r.bottom + 12) {
          bottom = Math.min(bottom, r.top - 12);
        }
      }
    }
    // A video is optional. If present, keep its native controls clear too.
    if (!open) {
      for (const stage of document.querySelectorAll('.takoo-creator__stage')) {
        const r = stage.getBoundingClientRect();
        if (r.height && r.width && r.bottom > 0 && r.top < innerHeight &&
            a.left < r.right + 8 && a.right > r.left - 8 &&
            bottom > r.bottom - 72 && bottom - a.height < r.bottom + 8) {
          bottom = Math.min(bottom, r.bottom - 80);
        }
      }
    }
    shift = open ? 0 : Math.min(0, Math.max(a.height + 12, bottom) - baseBottom);
    html.style.setProperty('--takoo-five-chat-shift', shift + 'px');
    // Supersede hidden-target treatments only on the five supported products.
    html.classList.remove('takoo-zh-purchase-chat-overlap', 'takoo-purchase-chat-overlap', 'takoo-video-chat-overlap');
  }
  for (const event of ['scroll','resize']) window.addEventListener(event, schedule, {passive:true});
  for (const event of ['click','change','transitionend','fullscreenchange']) document.addEventListener(event, schedule);
  const bar = document.querySelector('.sticky-add-to-cart__bar');
  if (bar) observer.observe(bar, {attributes:true, attributeFilter:['data-stuck','style','class']});
  observer.observe(document.body, {childList:true});
  customElements.whenDefined('shopify-chat').then(schedule);
  schedule();
}

